import { getGetSettingsQueryKey, getSettings } from 'api/generated/setting/setting'
import {
  GET_DRUG_RULES_SETTINGS,
  GET_DRUG_RULES_SETTINGS_ERROR,
  GET_DRUG_RULES_SETTINGS_SUCCESS,
} from './drugRulesSettingsConstants'
import { client } from 'api/components/queryClient'
import { store } from 'app/store'

export function getDrugRulesSettings() {
  getSettings()
    .then((response) => {
      const queryKey = getGetSettingsQueryKey()
      client.setQueryData(queryKey, response)
      store.dispatch({
        type: GET_DRUG_RULES_SETTINGS_SUCCESS,
        payload: response,
      })
    })
    .catch((error) => {
      store.dispatch({
        type: GET_DRUG_RULES_SETTINGS_ERROR,
        payload: error,
      })
    })
  return {
    type: GET_DRUG_RULES_SETTINGS,
  }
}
